import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
// import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
// import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Deposit = ()=>{
    const getCurrentDateTime = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const hours = String(currentDate.getHours()).padStart(2, '0');
        const minutes = String(currentDate.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const currentDateTime = getCurrentDateTime();
    const [deposit, setDeposit] = useState([]);
    const [page, setPage] = useState(1);
    const [total,setTotal] = useState(0)
    const [lastPage, setLastPage] = useState(1);
    const [searchDateFrom, setSearchDateFrom] = useState(currentDateTime);
    const [searchDateTo, setSearchDateTo] = useState(currentDateTime);
    const [errorMessage, setErrorMessage] = useState('');
    const[loading, setLoading] = useState(false);
    const [hasError,setHasError] = useState(false);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`depositTodayStudio?page=${page}`);
             
            setDeposit(data.data);
            setLastPage(data.meta.last_page)
            setTotal(data.meta.total);

        }
        )();
    },[page]);
 
    const doSearch  = async (e)=>{
        try {
            setLoading(true);
            const {data} = await axios.get(`depositDateSearchStudio?dateFrom=${searchDateFrom}&dateTo=${searchDateTo}&page=${page}`);
            setDeposit(data.data);
            //console.log(data.data);
            setLastPage(data.meta.last_page);
            setTotal(data.meta.total);
            setHasError(false);
        } catch (error) {
            setHasError(true);
            setLoading(false);
            setErrorMessage("Something went wrong, trya again later");
        } finally{
            setLoading(false);
        }

       
    }

    return (
        <Wrapper pageTitle={'Deposits'}>
             <div className="flex flex-col md:flex-row items-center md:items-center">
                <label className="block text-sm mr-2">
                    <span className="block mb-1">From Date</span>
                    <input 
                        type="datetime-local" 
                        value={searchDateFrom}
                        className="block w-full md:w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                        placeholder="From Date"
                        onChange={e => setSearchDateFrom(e.target.value)} 
                    />  
                </label>

                <label className="block text-sm mr-2">
                    <span className="block mb-1">To Date</span>
                    <input 
                        type="datetime-local" 
                        value={searchDateTo}
                        className="block w-full md:w-48 p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input"
                        placeholder="To Date"
                        onChange={e => setSearchDateTo(e.target.value)} 
                    />  
                </label>

                <div className="mt-2 md:mt-0">
                    <label className="block text-sm mr-2">
                        <button className="lex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-black border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple" onClick={doSearch}
                        disabled={loading}
                        >
                        {loading ? 'Searching...' : 'Search'}
                        </button>
                    </label>
                    {/* <button onClick={doDownload}>  </button> */}

                    <label className="block text-sm mr-2">
                        {hasError&&(
                            <>
                            <span className="text-rose-500">{errorMessage}</span>
                            </>
                        )}
                    </label>
                </div>
            </div>
            <div className="w-full overflow-x-auto bg-white text-right leading-10 text-purple-700 pr-2">  Page <span className="rounded-full bg-purple-700 text-white p-2">{page}</span>/{lastPage} Total Records: {total} </div>
            <Paginator lastPage={lastPage} pageChanged={setPage} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">TimeIn </th>
                                    <th className="px-4 py-3">PhoneNumber </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">MpesaReceiptNumber </th>
                                    <th className="px-4 py-3">Source </th>
                            
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {deposit.map((deposit)=>{
                                         return(
                                             <tr key={deposit.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{deposit.id}</td>
                                                 <td className="px-4 py-3 text-sm">{deposit.time_in}</td>
                                                 <td className="px-4 py-3 text-sm">{deposit.PhoneNumber}</td>
                                                 <td className="px-4 py-3 text-sm">{deposit.Amount}</td>
                                                 <td className="px-4 py-3 text-sm">{deposit.MpesaReceiptNumber}</td>
                                                 <td className="px-4 py-3 text-sm">{deposit.TransactionDesc}</td>
                                                 
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Deposit;